export default class PageObjectDefaultAttributes {
	/**
	 * getApplicationName - get application name
	 * @returns {string} application name - cms by default
	 */
	getApplicationName() {
		return 'cms';
	}

	/**
	 * getApplicationVersion - get application version
	 * @returns {string} application version
	 */
	getApplicationVersion() {
		let applicationVersion = '';
		let versions = document.getElementsByClassName('application-version');

		if (versions.length > 0) {
			applicationVersion = versions[0].getAttribute('data-version') || '';
		} else if (
			document.querySelectorAll('.nm-version-info dd') &&
			document.querySelectorAll('.nm-version-info dd').length > 0
		) {
			applicationVersion = document.querySelectorAll(
				'.nm-version-info dd',
			)[1].innerHTML;
		}

		return applicationVersion;
	}

	/**
	 * getImplementer - get agency id
	 * @returns {Number} agency id
	 */
	getImplementer() {
		return 1;
	}

	/**
	 * getSite - get site name
	 * @returns {string} site name
	 */
	getSite() {
		return 'product portal';
	}
}
